module.exports = __webpack_public_path__ + "static/media/customer_vendor_details.5c3d3a89.csv";